export default __webpack_public_path__ + "static/media/Milkys.e144564e.jpg";